import { ThemeUIStyleObject } from "theme-ui";

export const resetPrevNextButton: ThemeUIStyleObject = {
  ".swiper-button-prev, .swiper-button-next": {
    outline: "none",
    width: "44px",
    height: "44px",
    top: "50%",
    transform: "translate3d(0, -50%, 0)",
    marginTop: 0,
    borderRadius: "50%",
    border: "none",
    padding: 0,
    "svg circle": {
      fill: "lightGray",
      opacity: 1,
      transition: "all 0.2s",
    },
    "div svg": {
      marginLeft: 0,
      transition: "all 0.2s",
    },
    "svg path": {
      fill: "darkGreen",
      opacity: 1,
    },
    "&:hover, &:focus": {
      boxShadow: "none",
      backgroundColor: "#d0d1d2",
      "svg circle": {
        fill: "mediumGray",
        opacity: 0.3,
      },
      "div svg": {
        marginLeft: "0.4rem",
      },
    },
  },
  ".swiper-button-prev": {
    left: 2,
    "&:hover, &:focus": {
      boxShadow: "none",
      "svg circle": {
        fill: "mediumGray",
        opacity: 0.3,
      },
      "div svg": {
        marginLeft: "0",
        marginRight: "0.4rem",
        transition: "all 0.2s",
      },
    },
  },
  ".swiper-button-next": {
    right: 2,
  },
  ".swiper-button-prev:after, .swiper-button-next:after": {
    content: "none",
  },
};

export const mediaSliderContainerStyle: ThemeUIStyleObject = {
  position: "relative",
  width: "100%",
  mx: "auto",
  px: 0,
  zIndex: "dropdown",
  backgroundColor: "white",
};

const arrowBaseStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate3d(-50%, -50%, 0)",
  height: "16px",
};

export const leftArrowSpanStyles: ThemeUIStyleObject = {
  ...arrowBaseStyles,
};
export const rightArrowSpanStyles: ThemeUIStyleObject = {
  ...arrowBaseStyles,
};

export const leftArrowStyles: ThemeUIStyleObject = {
  transform: "rotate(180deg)",
};

export const rightArrowStyles: ThemeUIStyleObject = {};

export const ellipseStyles: ThemeUIStyleObject = {
  width: "44px",
  height: "44px",
  "> svg": {
    width: "full",
    height: "full",
  },
};

export const swiperStyles: ThemeUIStyleObject = {
  ...resetPrevNextButton,
  ".swiper-pagination": {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "max-content",
    ml: 0,
    mr: 0,
    paddingTop: "1rem",
    paddingBottom: ["1rem", null, 0],
    width: "auto",
  },
  ".swiper-pagination-bullet": {
    position: "relative",
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "transparent",
    bg: "transparent",
    margin: "0 10px",
    opacity: 1,
    ":before": {
      content: "''",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate3d(-50%, -50%, 0)",
      bg: "darkGreen",
      width: "5px",
      height: "5px",
      borderRadius: "50%",
    },
    ":after": {
      content: "''",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate3d(-50%, -50%, 0)",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "transparent",
      width: "0px",
      height: "0px",
      borderRadius: "50%",
      transition: "all 0.15s",
    },
    ":hover, :focus": {
      ":before": {
        bg: "darkGreen",
      },
      ":after": {
        width: "16px",
        height: "16px",
        borderColor: "darkGreen",
      },
    },
  },
  ".swiper-pagination-bullet-active": {
    ":after": {
      width: "16px",
      height: "16px",
      borderColor: "darkGreen",
    },
    ":before": {
      bg: "darkGreen",
    },
  },

  ".swiper-button-prev.swiper-button-disabled, .swiper-button-next.swiper-button-disabled":
    {
      opacity: 0.5,
    },
};
